module.exports = __webpack_public_path__ + "img/pin-btn.1220e08d.jpg";